import { render, staticRenderFns } from "./AppSnackbar.vue?vue&type=template&id=cff658a8&scoped=true&"
import script from "./AppSnackbar.vue?vue&type=script&lang=ts&"
export * from "./AppSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./AppSnackbar.vue?vue&type=style&index=0&id=cff658a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff658a8",
  null
  
)

export default component.exports